module.exports = __webpack_public_path__ + "img/content2.bd87aa36.png";